/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getRouteInitData } from '@gh/common-shared';
import { assign } from 'lodash';
import { JobBasicInfo } from '../resources/job-details-tab/job-details-tab-model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class JobDetailsModel {
  basicInfo: JobBasicInfo;
  basicInfo$: Observable<JobBasicInfo>;
  reportUrl: string;
// @ts-expect-error Legacy typing suppression
  private _basicInfo = new BehaviorSubject<JobBasicInfo>({});
  constructor(route: ActivatedRoute) {
    const { basicInfo, reportUrl } = getRouteInitData(route);

    assign(this, { basicInfo, reportUrl });
    this._basicInfo.next(this.basicInfo);
    this.basicInfo$ = this._basicInfo.asObservable();
  }

  get jobNumber(): number {
    return this.basicInfo.jobNumber;
  }

  updateBasicInfo(basicInfo: JobBasicInfo): void {
    this.basicInfo = basicInfo;
    this._basicInfo.next(basicInfo);
  }
}
